import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Select,
    MenuItem,
    FormControl, InputLabel
} from "@material-ui/core";
import {useMemo, useState} from "react";
import {nanoid} from "@reduxjs/toolkit";
import useUserList from "../../../shared/functions/useUserList";
import {initialState, useStyles, states} from "../constants";
import {Col, Row} from "react-bootstrap";
import IconButton from "@material-ui/core/IconButton";

import CloseIcon from "@material-ui/icons/Close";
import {useSelector} from "react-redux";
import {selectOrders} from "../../../redux/slices/orders";


export default function FilterModal({onClose, show, onSet}) {
    const classes = useStyles();
    const [filter, setFilter] = useState(initialState)
    const {users: list} = useUserList();
    const users = useMemo(() => (list && list.map(user => ({value: user.id, label: user?.name || user?.displayName || user?.email}))) ?? [], [list])
    const {snapshot} = useSelector(selectOrders)

    const handleClosing = () => {
        onClose && onClose()
    }

    const handleStateSelection = (newState) => {
        setFilter({...filter, state: newState})
    }

    const handleUserSelection = (userId) => {
        setFilter({...filter, user: userId})
    }

    const handleReset = () => {
        setFilter(initialState)
    }

    const handleApplyFilter = () => {
        onSet && onSet(filter)
        handleClosing()
    }

    return (
        <Dialog open={show} onClose={handleClosing} maxWidth='sm' fullWidth>
            <DialogTitle>
                <Row>
                    <Col className='col-auto text-truncate' style={{display: 'grid', placeItems: 'center'}}>
                        Filtre
                    </Col>
                    <Col className='col-auto ml-auto'>
                        <IconButton onClick={handleClosing}>
                            <CloseIcon/>
                        </IconButton>
                    </Col>
                </Row>
            </DialogTitle>

            <DialogContent>

                <FormControl className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">Etat</InputLabel>
                    <Select value={filter.state} className={classes.select}
                            onChange={event => handleStateSelection(event.target.value)}>
                        {
                            states.map(({label, value}) => (
                                <MenuItem value={value} key={nanoid()}>{label}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>

                <FormControl className={classes.formControl}>
                    <InputLabel id="demo-simple-select-label">Utilisateur</InputLabel>
                    <Select value={String(filter.user)} className={classes.select}
                            onChange={event => handleUserSelection(event.target.value)}>
                        <MenuItem value={'you'}>Vous</MenuItem>
                        <MenuItem value={'all'}>Tout le monde</MenuItem>
                        {
                            users.map(({label, value}) => (
                                <MenuItem value={value} key={nanoid()}>{label}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>

            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={handleReset}>
                    Reset
                </Button>
                <Button variant='contained' color='primary'
                        onClick={handleApplyFilter}
                        disabled={snapshot.filter === filter}
                >
                    Appliquer
                </Button>
            </DialogActions>
        </Dialog>
    )
}